import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SecondOpinionService {
     private subject = new Subject<any>();

    sendSecondOpinionMessage(message: string) {
        this.subject.next(message);
    }

    clearSecondOpinionMessages() {
        this.subject.next();
    }

    getSecondOpinionMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}